import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../stores/authStore';

/**
 * OnboardingGate
 *
 * Wrapper fuer die Dashboard-Index-Route: wenn der eingeloggte User noch
 * keinen Onboarding-Abschluss hat, Redirect auf /onboarding.
 *
 * Wird bewusst NUR um die Index-Route gelegt — so kann der User trotzdem
 * /onboarding selbst besuchen und andere Seiten (z.B. /settings) sind auch
 * waehrend des Onboardings erreichbar, falls der Lead sie explizit freigibt.
 */
export default function OnboardingGate({ children }) {
  const user = useAuthStore((s) => s.user);
  const isLoading = useAuthStore((s) => s.isLoading);
  const location = useLocation();

  // Auth noch am Laden — neutraler Pass-Through, ProtectedRoute kuemmert sich.
  if (isLoading) return children;

  // Kein User — ProtectedRoute sollte vorher greifen, aber safety net.
  if (!user) return children;

  // Bereits im Onboarding — nicht erneut redirecten.
  if (location.pathname.startsWith('/onboarding')) return children;

  // Wenn User Onboarding noch nicht abgeschlossen hat → dorthin.
  if (!user.onboardingCompletedAt) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
